import axios from 'axios';

export const cohortApi = {
  getAll: (tenantId: string) => {
    return axios.get(`/api/cohorts/tenant/${tenantId}`);
  },
};
